module.exports = __webpack_public_path__ + "img/scheduled.e76a651b.svg";